export default {
  // Header
  "title": "Gerador Aleatório de Pokémon",
  "subtitle": "Gere Pokémon aleatórios baseados nas suas preferências",
  "home": "Início",
  "whichPokemonAmI": "Que Pokémon Sou Eu?",
  "aboutUs": "Sobre Nós",
  "contactUs": "Contato",
  "privacyPolicy": "Política de Privacidade",
  
  // Filters
  "filterTitle": "Opções de Filtro",
  "generateButton": "Gerar Pokémon Aleatórios",
  "generating": "Gerando...",
  "numberOfPokemon": "Número de Pokémon",
  "type": "Tipo",
  "generation": "Geração",
  "minimumRarity": "Raridade Mínima (1-10)",
  "anyType": "Qualquer Tipo",
  "anyGeneration": "Qualquer Geração",
  "anyRarity": "Qualquer Raridade",
  "countingPokemon": "Contando Pokémon correspondentes",
  "matchingPokemonCount": "{{count}} Pokémon correspondem aos seus filtros",
  "noPokemonToDisplay": "Nenhum Pokémon para exibir. Gere alguns Pokémon!",
  
  // Pokemon Types
  "normal": "Normal",
  "fire": "Fogo",
  "water": "Água",
  "electric": "Elétrico",
  "grass": "Planta",
  "ice": "Gelo",
  "fighting": "Lutador",
  "poison": "Venenoso",
  "ground": "Terra",
  "flying": "Voador",
  "psychic": "Psíquico",
  "bug": "Inseto",
  "rock": "Rocha",
  "ghost": "Fantasma",
  "dragon": "Dragão",
  "dark": "Sombrio",
  "steel": "Aço",
  "fairy": "Fada",
  
  // Generations
  "Generation I": "Geração I",
  "Generation II": "Geração II",
  "Generation III": "Geração III",
  "Generation IV": "Geração IV",
  "Generation V": "Geração V",
  "Generation VI": "Geração VI",
  "Generation VII": "Geração VII",
  "Generation VIII": "Geração VIII",
  "Generation IX": "Geração IX",
  
  // Evolution Stage
  "evolutionStage": "Estágio de Evolução",
  "evolutionStageAll": "Todos os Estágios",
  "evolutionStageFullyEvolved": "Totalmente Evoluído",
  "evolutionStageNotFullyEvolved": "Não Totalmente Evoluído",
  
  // About Section
  "aboutTitle": "Sobre o Gerador Aleatório de Pokémon",
  
  // Section titles
  "introTitle": "Bem-vindo ao Nosso Gerador Aleatório de Pokémon",
  "howToUseTitle": "Como Usar o Gerador Aleatório de Pokémon",
  "benefitsTitle": "Benefícios de Usar Nosso Gerador Aleatório de Pokémon",
  "historyTitle": "História de Pokémon",
  "popularPokemonTitle": "Pokémon Populares",
  "popularGamesTitle": "Jogos Populares de Pokémon",
  "tradingContestsTitle": "Trocas e Concursos de Pokémon",
  "faqTitle": "Perguntas Frequentes",
  "conclusionTitle": "Comece Sua Aventura Aleatória Pokémon Hoje!",
  
  // Footer
  "copyright": "© 2025 randompokemon.games",
  "trademark": "Pokémon e os nomes dos personagens Pokémon são marcas registradas da Nintendo.",
  "linksTitle": "Links Úteis",
  
  // About Us Page
  "aboutUsTitle": "Sobre Nós",
  "aboutUsWhoWeAre": "Quem Somos",
  "aboutUsWhoWeAreContent1": "Bem-vindo ao Gerador Aleatório de Pokémon, uma ferramenta criada por fãs entusiastas de Pokémon. Nossa jornada começou em 2023, quando um grupo de desenvolvedores que amam programação e Pokémon decidiu criar uma ferramenta útil para a comunidade.",
  "aboutUsWhoWeAreContent2": "Nossa equipe é composta por desenvolvedores, designers e criadores de conteúdo que trabalham juntos para proporcionar a melhor experiência possível aos fãs de Pokémon em todo o mundo.",
  "aboutUsOurMission": "Nossa Missão",
  "aboutUsOurMissionContent1": "Buscamos tornar o mundo de Pokémon mais acessível e divertido para todos. Nossas ferramentas são projetadas para ajudar treinadores a descobrir novos Pokémon, criar equipes equilibradas e encontrar o seu Pokémon perfeito.",
  "aboutUsOurMissionContent2": "Estamos comprometidos em fornecer uma experiência amigável, precisa e divertida que respeita a franquia Pokémon enquanto agrega valor à comunidade.",
  "aboutUsOurTeam": "Nossa Equipe",
  "aboutUsOurTeamContent1": "Nossa equipe diversificada reúne expertise em desenvolvimento web, conhecimento de Pokémon, design de experiência do usuário e gerenciamento de comunidade. Estamos unidos pelo nosso amor por Pokémon e pelo compromisso de criar ferramentas de alta qualidade.",
  "aboutUsOurTeamContent2": "Cada membro da equipe contribui com suas habilidades e perspectivas únicas para fazer do Gerador Aleatório de Pokémon o melhor possível.",
  "aboutUsJoinUs": "Junte-se a Nós",
  "aboutUsJoinUsContent": "Estamos sempre procurando indivíduos apaixonados para se juntar à nossa comunidade. Seja você um desenvolvedor, designer, especialista em Pokémon ou um usuário entusiasta, seus comentários e contribuições são bem-vindos.",
  
  // Contact Us Page
  "contactUsTitle": "Contato",
  "contactUsGetInTouch": "Entre em Contato",
  "contactUsGetInTouchContent": "Tem perguntas, sugestões ou feedback sobre o Gerador Aleatório de Pokémon? Gostaríamos de ouvir você! Aqui está como você pode entrar em contato com nossa equipe.",
  "contactUsEmail": "Email",
  "contactUsPhone": "Telefone",
  "contactUsAddress": "Endereço",
  "contactUsHelpSupport": "Ajuda e Suporte",
  "contactUsHelpSupportContent": "Precisa de ajuda para usar nossas ferramentas ou encontrou um problema? Nossa equipe de suporte está aqui para ajudar.",
  "contactUsFAQ": "Perguntas Frequentes",
  "contactUsFAQContent": "Antes de nos contatar, por favor confira nossa seção de FAQ que cobre muitas perguntas e problemas comuns.",
  "contactUsBugReport": "Relatório de Bug",
  "contactUsBugReportContent": "Se você encontrou um bug ou problema técnico, por favor nos informe enviando um e-mail com 'RELATÓRIO DE BUG' no assunto.",
  
  // Privacy Policy Page
  "privacyPolicyTitle": "Política de Privacidade",
  "privacyPolicyIntro": "Introdução",
  "privacyPolicyIntroContent": "No Gerador Aleatório de Pokémon, respeitamos sua privacidade e estamos comprometidos em proteger seus dados pessoais. Esta Política de Privacidade explica como coletamos, usamos e protegemos suas informações quando você usa nosso site.",
  "privacyPolicyInformation": "Informações que Coletamos",
  "privacyPolicyInformationContent": "Coletamos o mínimo de informações para fornecer e melhorar nossos serviços. Isso pode incluir:",
  "privacyPolicyInformationItem1": "Dados de uso (como páginas visitadas, tempo gasto no site e recursos utilizados)",
  "privacyPolicyInformationItem2": "Informações do dispositivo (tipo de navegador, sistema operacional e resolução de tela)",
  "privacyPolicyInformationItem3": "Endereço IP e localização aproximada (apenas em nível de país)",
  "privacyPolicyCookies": "Cookies e Tecnologias Semelhantes",
  "privacyPolicyCookiesContent": "Usamos cookies para melhorar sua experiência em nosso site. Esses pequenos arquivos de texto nos permitem lembrar suas preferências e analisar o uso do nosso site. Você pode controlar os cookies através das configurações do seu navegador.",
  "privacyPolicyThirdParty": "Serviços de Terceiros",
  "privacyPolicyThirdPartyContent": "Nosso site pode usar serviços de terceiros, como provedores de análise e redes de distribuição de conteúdo. Esses serviços podem coletar informações sobre seu uso do nosso site. Garantimos que todos os terceiros respeiem sua privacidade e tratem os dados adequadamente.",
  "privacyPolicySecurity": "Segurança de Dados",
  "privacyPolicySecurityContent": "Implementamos medidas de segurança apropriadas para proteger suas informações contra acesso, alteração ou divulgação não autorizados. No entanto, nenhuma transmissão pela Internet é 100% segura, então não podemos garantir segurança absoluta.",
  "privacyPolicyChanges": "Alterações nesta Política",
  "privacyPolicyChangesContent": "Podemos atualizar nossa Política de Privacidade de tempos em tempos. Notificaremos você sobre quaisquer alterações publicando a nova Política de Privacidade nesta página e atualizando a data de 'última atualização'.",
  "privacyPolicyContact": "Contate-nos",
  "privacyPolicyContactContent": "Se você tiver alguma dúvida sobre esta Política de Privacidade, entre em contato conosco através das informações fornecidas em nossa página de Contato.",
  "privacyPolicyLastUpdated": "Última Atualização",
  
  // Which Pokemon Am I Page
  "whichPokemonAmITitle": "Que Pokémon Sou Eu?",
  "whichPokemonAmISubtitle": "Descubra qual Pokémon combina melhor com você",
  "enterYourName": "Digite seu nome",
  "namePlaceholder": "Seu nome",
  "enterFavoriteColor": "Escolha sua cor favorita",
  "enterBirthMonth": "Escolha seu mês de nascimento",
  "selectBirthMonth": "Selecione um mês",
  "enterPersonalityTrait": "Escolha uma característica de personalidade",
  "selectPersonalityTrait": "Selecione uma característica",
  "findMyPokemon": "Encontrar meu Pokémon",
  "calculating": "Calculando...",
  "yourPokemonIs": "Seu Pokémon é",
  "pokemonDescription": "Descrição",
  "personalityMatch": "Compatibilidade de personalidade",
  "yourCompatibility": "Sua compatibilidade",
  "downloadImage": "Baixar imagem",
  "shareResult": "Compartilhar resultado",
  "tryAgain": "Tentar novamente",
  "results": "Resultados",
  "aboutTool": "Sobre esta ferramenta",
  "howToUse": "Como usar",
  "benefits": "Benefícios",
  "faq": "FAQ",
  "conclusion": "Conclusão",
  
  // Error messages
  "nameRequired": "Nome é obrigatório",
  "colorRequired": "Por favor escolha uma cor",
  "monthRequired": "Por favor escolha um mês",
  "traitRequired": "Por favor escolha uma característica de personalidade",
  
  // Months
  "january": "Janeiro",
  "february": "Fevereiro",
  "march": "Março",
  "april": "Abril",
  "may": "Maio",
  "june": "Junho",
  "july": "Julho",
  "august": "Agosto",
  "september": "Setembro",
  "october": "Outubro",
  "november": "Novembro",
  "december": "Dezembro",
  
  // Personality Traits
  "brave": "Corajoso",
  "calm": "Calmo",
  "timid": "Tímido",
  "jolly": "Alegre",
  "quiet": "Quieto",
  "hasty": "Apressado",
  "careful": "Cuidadoso",
  "lonely": "Solitário",
  "bold": "Ousado",
  "relaxed": "Relaxado",
  "impish": "Travesso",
  "modest": "Modesto",
  
  // Additional translations for size matching feature
  "heightValid": "Por favor insira uma altura válida (1-300 cm)",
  "weightValid": "Por favor insira um peso válido (1-500 kg)",
  "enterDetails": "Digite seus detalhes",
  "nameLabel": "Nome",
  "heightLabel": "Altura",
  "weightLabel": "Peso",
  "finding": "Procurando...",
  "errorFinding": "Erro ao encontrar seu Pokémon",
  "matchResult": "O Pokémon de {{name}} é...",
  "similarityScore": "Pontuação de Similaridade",
  "downloadStarted": "Preparando sua imagem...",
  "downloadComplete": "Imagem baixada com sucesso!",
  "shareText": "Descobri que sou {{pokemon}}! Descubra qual Pokémon você é também!",
  
  // Size matching feature
  "enterHeightWeight": "Digite sua altura e peso — veja qual Pokémon combina com você!",
  "whichPokemonMatchesSize": "Qual Pokémon combina com o seu tamanho?",
  "youAreMostLike": "Você é mais parecido com",

  // New Page: Pokemon Randomizer - About Section Titles (Translated to Portuguese)
  "pokemonRandomizerPageAboutTitle": "Explore a Experiência Definitiva do Randomizador de Pokémon",
  "pokemonRandomizer_whatIsItTitle": "O Que Exatamente é um Randomizador de Pokémon?",
  "pokemonRandomizer_featuresTitle": "Principais Características da Nossa Ferramenta Randomizador de Pokémon",
  "pokemonRandomizer_whyUseTitle": "Por Que Embarcar em uma Aventura com um Randomizador de Pokémon?",
  "pokemonRandomizer_gettingStartedTitle": "Primeiros Passos: Sua Primeira Jogada com o Randomizador de Pokémon",
  "pokemonRandomizer_faqTitle": "Randomizador de Pokémon: Perguntas Frequentes",

  // New keys for PokemonRandomizerPage.tsx H1 and subtitle (Translated to Portuguese)
  "pokemonRandomizerPageH1": "Randomizador de Pokémon",
  "pokemonRandomizerPageSubtitle": "Crie experiências Pokémon únicas com nossa ferramenta avançada de randomização.",

  // Additional translations for the new 'madeBy' field
  "madeBy": "Feito por",

  // Sub-Footer
  subFooterToolsTitle: "Ferramentas",
  subFooterRandomPokemonGeneratorLink: "Gerador Aleatório de Pokémon",
  subFooterPokemonRandomizerLink: "Randomizador de Pokémon",
  subFooterWhichPokemonAmILink: "Qual Pokémon Eu Sou?",

  subFooterPokemonDatabaseTitle: "Banco de Dados Pokémon",
  subFooterPokedexLink: "Pokédex (Em Breve)",
  subFooterTypeChartsLink: "Tabelas de Tipos (Em Breve)",
  subFooterMoveListLink: "Lista de Movimentos (Em Breve)",

  subFooterBlogTitle: "Blog",
  subFooterLatestArticlesLink: "Artigos Mais Recentes (Em Breve)",
  subFooterGuidesTutorialsLink: "Guias e Tutoriais (Em Breve)"
};
